export default "__VITE_ASSET__CaiCr9Q$__"